import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex w-full flex-col items-center justify-center rounded-lg border border-background-200 bg-background-50 px-6 py-16 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
        <i className={`${icon} text-3xl`} aria-hidden="true" />
      </div>
      <h3 className="mt-5 text-lg font-bold text-foreground-900">{title}</h3>
      {description && (
        <p className="mt-2 max-w-md text-sm text-foreground-500">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}